export const NUMBER_OF_DOWNLOADS = 40;
export const NavHeight = 72;
export const appLink = "https://play.google.com/store/apps/details?id=com.gromo.partner&hl=en_IN";
